import {request} from "../request/request";

const schoolClass = {
  all: (params) => request.read('/school-class', params),
};

export {schoolClass};